export default __webpack_public_path__ + "static/media/man.5f3108f0.png";